<script setup lang="ts">
const theme = useTheme()
const { navOpen, collapsed } = useNav()
const toasts = useToasts()
const view = useCurrentView()
const route = useRoute()
const isLoginPage = computed(() => route.path === '/login')

useHead({ htmlAttrs: { 'data-theme': theme } })

// Comme la maquette : le thème du système au démarrage (sauf choix explicite mémorisé), et les menus se ferment au clic ailleurs ou sur Échap
onMounted(() => {
  const saved = localStorage.getItem('theme')
  theme.value = saved === 'dark' || saved === 'light' ? saved : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  document.addEventListener('click', (e) => {
    const target = e.target as Element
    if (!target.closest('#notif-wrap')) closeNotifMenu()
    if (!target.closest('.ctx-wrap')) closeCtxMenu()
    useTable().openMenu.value = null
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCtxMenu()
      closeNotifMenu()
    }
  })
})

// Le menu se déplie selon la vue affichée (aussi au retour arrière du navigateur)
watch(view, v => applyExpansion(v.type, v.key, v.id), { immediate: true })
</script>

<template>
  <a
    class="skip"
    href="#content"
  >Aller au contenu</a>

  <NuxtPage v-if="isLoginPage" />
  <div
    v-else
    id="app"
    :class="{ 'nav-open': navOpen, 'collapsed': collapsed }"
  >
    <AppSidebar />
    <div
      class="nav-scrim"
      @click="toggleSidebar()"
    />

    <div class="col">
      <AppTopbar />
      <main>
        <div
          id="content"
          tabindex="-1"
        >
          <NuxtPage />
        </div>
      </main>
    </div>

    <AppTabbar />
  </div>

  <div id="modal-root" />
  <div
    id="toast-root"
    role="status"
    aria-live="polite"
  >
    <div
      v-for="t in toasts"
      :key="t.id"
      class="toast"
    >
      {{ t.msg }}
    </div>
  </div>
</template>
